/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { actions } from '../../utils/constants';
import history from '../../history';
import routes from '../../utils/routes';

import {
    updateTemplateQuestions,
    fetchTemplateQuestion,
} from '../../utils/common-functions';

function* updateQuestion({
    payload: { questionId, question, options, enabled },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const serializeOptions = options.map(option => {
            return !option.removed
                ? { ...option }
                : {
                      id: option.id,
                      removed: option.removed,
                  };
        });

        const paramsUpdateQuestion = {
            title: question,
            enabled: enabled,
            options: serializeOptions,
        };

        yield call(updateTemplateQuestions, {
            questionId,
            data: paramsUpdateQuestion,
        });
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        history.push(routes.QUESTIONS_DATABASE);
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível atualizar a questão',
            },
        });
    }
}

function* fetchQuestionToManage({ payload: { questionId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const response = yield call(fetchTemplateQuestion, { questionId });
        yield put({
            type: actions.CHANGE_QUESTION_TO_MANAGE,
            payload: response.data,
        });
    } catch (err) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível listar detalhes da questão',
            },
        });
    }

    yield put({
        type: actions.DECREMENT_LOADING_ONLINE_TESTS,
    });
}

export default function* manageQuestion() {
    yield takeEvery(actions.ASYNC_UPDATE_QUESTION, updateQuestion);
    yield takeEvery(
        actions.ASYNC_FETCH_QUESTION_TO_MANAGE,
        fetchQuestionToManage,
    );
}



// WEBPACK FOOTER //
// ./src/components/manage-question/manage-question.saga.js